import ReactDOMServer from 'react-dom/server';
import React from 'react';
import styles from './styles';
import DragScroller from './DragScroller';

/**
 * Returns the body of the generated HTML as a string.
 * @function body
 * @returns {string} The body of the generated HTML as a string.
 */
export const body = () => {
  return (`${ReactDOMServer.renderToStaticMarkup(
    <body>
      <div 
        className="layout-container" 
        role="button" 
        tabIndex={0} 
        onMouseDown={(e) => DragScroller.StartScroll(e)} 
        onMouseMove={(e) => DragScroller.ScrollNow(e)}
        onMouseUp={() => DragScroller.StopScroll()}
        onMouseLeave={() => DragScroller.StopScroll()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            DragScroller.StartScroll(e);
          }
        }}
      >
      </div>
    </body>
  )}`);
};

/**
 * Returns the head of the generated HTML as a string.
 * @function head
 * @returns {string} The head of the generated HTML as a string.
 */
export const head = () => {
  return (`
    <head>
      <link href="https://fonts.googleapis.com/css?family=Cabin:400,700" rel="stylesheet">
      <link href="https://fonts.googleapis.com/css?family=Raleway:700" rel="stylesheet">
      <style media="screen" type="text/css">
          ${styles}
      </style>
    </head>
  `);
};
